export default "__VITE_ASSET__314083e1__"